import { clamp } from 'lodash';

/**
 * Calculate the extra charges for additional attributions
 * based on the payment plan and totalAttributions from current charge
 *
 * @param {Object} paymentPlan
 * @param {Number} totalAttributions
 * @return {Object}
 */
export function getExtraCharge(paymentPlan = {}, totalAttributions = 0) {
  const { included_attributions = 1, attribution_price = 0 } = paymentPlan;

  const additionalAttributions = clamp(totalAttributions - included_attributions, 0, Infinity);
  const total = additionalAttributions * attribution_price;
  const progress = (totalAttributions / included_attributions) * 100;

  if (included_attributions < 0) {
    return {
      total: 0,
      additionalAttributions: 0,
      progress: '0%',
    };
  }

  return {
    total,
    additionalAttributions,
    progress: `${Math.round(clamp(progress, 100))}%`,
  };
}
